
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/general",
      function () {
        return require("private-next-pages/services/general.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/general"])
      });
    }
  